export function pack(data) {
  return btoa(JSON.stringify(data))
}

export function unpack(data) {
  return JSON.parse(atob(data))
}
